import { type PayloadAction, createSlice } from '@reduxjs/toolkit'
import type { WidgetConfig } from '../types'

const initialState: {
  locationTypes: WidgetConfig['locationTypes']
} = {
  locationTypes: []
}

export const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setData(_state, action: PayloadAction<typeof initialState>) {
      return {
        locationTypes: action.payload.locationTypes
      }
    }
  }
})

export const dataActions = dataSlice.actions
